var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDbProvSeekInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,450V60h-60V0H60v60H0v390h161v2c0,16.5-13.5,30-30,30H61v30h390v-30h-70c-16.5,0-30-13.5-30-30v-2H512z  M482,90v270h-30V90H482z M422,30v330H90V30H422z M60,90v270H30V90H60z M30,390h452v30H30V390z M329.1,482H182.9 c5.1-8.8,8.1-19.1,8.1-30v-2h130v2C321,462.9,323.9,473.2,329.1,482z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 240,
    className: "st0",
    width: 121,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 300,
    className: "st0",
    width: 121,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226,240H120v90h106V240z M196,300h-46v-30h46V300z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.5,195c0-24-11.5-46.5-30.5-60.6V105c0-24.8-20.2-45-45-45s-45,20.2-45,45v29.4 c-19,14.1-30.5,36.6-30.5,60.6v15h151V195z M213.1,180c3.6-10.2,10.7-19,20.4-24.5l7.5-4.3V105c0-8.3,6.7-15,15-15 c8.3,0,15,6.7,15,15v46.2l7.5,4.3c9.6,5.5,16.8,14.3,20.4,24.5H213.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbProvSeekInformation);
export default __webpack_public_path__ + "static/media/DB-prov-seek-information.4b4893b1c95c2fe3ac7b0c8523109622.svg";
export { ForwardRef as ReactComponent };